
export default function Metals() {
  return (
    <section id="metals" className="py-16 lg:py-20 bg-[#FAFAFA]">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-8">

        <div className="text-center mb-14">
          <h2 className="text-3xl lg:text-[38px] font-semibold text-[#111111]">
            Precious Metals Advisory
          </h2>
          <p className="mt-5 text-[17px] text-[#666666] leading-relaxed">
            Strategic intelligence and network development in Asia's precious metals markets.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-stretch gap-1 lg:gap-12">
          {/* Image left */}
          <div className="w-full lg:w-1/2 flex-shrink-0">
            <div className="w-full h-auto lg:h-full lg:min-h-[400px] rounded-2xl overflow-hidden">
              <img
                src="https://static.readdy.ai/image/2e4355bb8afb16b3015e9a84e75a64ec/b36329b306ab9f6da11b3290550a9f74.png"
                alt="Precious Metals Advisory"
                className="w-full h-auto lg:h-full object-cover object-center"
              />
            </div>
          </div>

          {/* Content right */}
          <div className="w-full lg:w-1/2 space-y-10">
            <div className="flex items-start gap-5">
              <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center bg-[#B11226]/10 rounded-xl">
                <i className="ri-bar-chart-box-line text-2xl text-[#B11226]"></i>
              </div>
              <div>
                <h3 className="text-[17px] font-semibold text-[#111111] mb-1">Asia Demand Signals</h3>
                <p className="text-[15px] text-[#666666] leading-relaxed">
                  Market intelligence on demand trends, pricing dynamics, and emerging opportunities across Asian precious metals markets.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-5">
              <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center bg-[#B11226]/10 rounded-xl">
                <i className="ri-map-pin-line text-2xl text-[#B11226]"></i>
              </div>
              <div>
                <h3 className="text-[17px] font-semibold text-[#111111] mb-1">Ecosystem Mapping</h3>
                <p className="text-[15px] text-[#666666] leading-relaxed">
                  Comprehensive mapping of trading networks, refining operations, logistics infrastructure, and vaulting services.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-5">
              <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center bg-[#B11226]/10 rounded-xl">
                <i className="ri-team-line text-2xl text-[#B11226]"></i>
              </div>
              <div>
                <h3 className="text-[17px] font-semibold text-[#111111] mb-1">Partner Introductions</h3>
                <p className="text-[15px] text-[#666666] leading-relaxed">
                  Strategic partner connections and execution support to facilitate market entry and operational development.
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
